<template>
  <div class="no-permission">
    <i class="el-icon-lock"></i>
    <h2>无访问权限</h2>
    <p>当前账号的角色没有该页面的权限，请联系管理员在「角色管理」中分配。</p>
    <el-button type="danger" size="small" @click="handleLogout">退出登录</el-button>
  </div>
</template>

<script>
export default {
  name: 'NoPermission',
  methods: {
    handleLogout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style scoped>
.no-permission {
  background: #fff;
  border-radius: 4px;
  padding: 80px 24px;
  text-align: center;
  color: #606266;
}

.no-permission i {
  font-size: 56px;
  color: #E4393C;
}

.no-permission h2 {
  margin: 16px 0 8px;
  font-size: 18px;
  color: #303133;
}

.no-permission p {
  margin: 0 0 24px;
  font-size: 13px;
  color: #909399;
}
</style>
